var RemindOverviewComponent = (function () {
    function RemindOverviewComponent() {
    }
    return RemindOverviewComponent;
}());
export { RemindOverviewComponent };



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/theme/components/remind-overview/remind-overview.component.ts.pre-build-optimizer.js